export const FotosData = [
    {
        id:'1',
        img: require('../Imagenes/imgMachuPichu/foto1.jpg'),
        Title:'Perú',
       Link:'/fotos/MachuPichu'
    },
{
    id:'2',
    img:require('../Image/Rioplyas.jpg'),
    Title:'Kayak',
    Link:'/fotos/Rioplayas'

},
{
    id:'3',
    img:'https://upload.wikimedia.org/wikipedia/commons/4/4b/Montaje_de_la_Ciudad_de_Buenos_Aires.png',
    Title:'Cuenca',
    Link:'#'

},
{
    id:'4',
    img:'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Rome_Montage_2017.png/375px-Rome_Montage_2017.png',
    Title:'Galapagos',
    Link:'#'

},
{
    id:'5',
    img:'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Rome_Montage_2017.png/375px-Rome_Montage_2017.png',
    Title:'working',

},
    
    
    ];